import { render, staticRenderFns } from "./UserAccountProfileBasicVerifyEmail.vue?vue&type=template&id=67ebd756&"
import script from "./UserAccountProfileBasicVerifyEmail.vue?vue&type=script&lang=js&"
export * from "./UserAccountProfileBasicVerifyEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports